module.exports = __webpack_public_path__ + "static/cercazone_sudest2-92bd4326d227680c48485a7ebb1de61b.jpg";